import { render, staticRenderFns } from "./taskCustomFields.vue?vue&type=template&id=5fa92d1b&"
import script from "./taskCustomFields.vue?vue&type=script&lang=js&"
export * from "./taskCustomFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports